"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ArchiveDrawer: ['archive-drawer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,15.75H15a3,3,0,0,1-6,0H1.5a.75.75,0,0,0-.75.75v3.75a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V16.5A.75.75,0,0,0,22.5,15.75Z', 'M21.75,12.75v-9a1.5,1.5,0,0,0-1.5-1.5H10.5A1.5,1.5,0,0,0,9,3.75v9', 'M2.25,12.75v-6a1.5,1.5,0,0,1,1.5-1.5H6', 'M14.999 6.75L18.75 6.75', 'M11.999 10.5L18.75 10.5']],
  ArchiveLocker: ['archive-locker', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.751 0.750 L23.250 0.750 L23.250 23.250 L0.751 23.250 Z', 'M0.751 8.25L23.249 8.25', 'M0.751 15.75L23.249 15.75', 'M15,18.75a.75.75,0,0,1-.75.75h-4.5A.75.75,0,0,1,9,18.75', 'M15,11.25a.75.75,0,0,1-.75.75h-4.5A.75.75,0,0,1,9,11.25', 'M15,3.75a.75.75,0,0,1-.75.75h-4.5A.75.75,0,0,1,9,3.75']],
  ArchiveBooks: ['archive-books', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 0.750 L12.000 0.750 L12.000 23.250 L3.000 23.250 Z', 'M12.000 0.750 L21.000 0.750 L21.000 23.250 L12.000 23.250 Z', 'M15.000 18.750 A1.500 1.500 0 1 0 18.000 18.750 A1.500 1.500 0 1 0 15.000 18.750 Z', 'M6.000 18.750 A1.500 1.500 0 1 0 9.000 18.750 A1.500 1.500 0 1 0 6.000 18.750 Z', 'M6.000 4.500 L9.000 4.500 L9.000 14.250 L6.000 14.250 Z', 'M15.000 4.500 L18.000 4.500 L18.000 14.250 L15.000 14.250 Z']],
  Archive: ['archive', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,9.75v9a3,3,0,0,1-3,3H5.25a3,3,0,0,1-3-3v-9', 'M21.75,2.25H2.25a1.5,1.5,0,0,0-1.5,1.5v3h22.5v-3A1.5,1.5,0,0,0,21.75,2.25Z', 'M15,11.25a1.5,1.5,0,0,1-1.5,1.5h-3a1.5,1.5,0,0,1,0-3h3A1.5,1.5,0,0,1,15,11.25Z']],
  ArchiveDrawerTable: ['archive-drawer-table', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,21.75H5.25a3,3,0,0,1-3-3V.75h19.5v18A3,3,0,0,1,18.75,21.75Z', 'M5.25 21.75L5.25 23.25', 'M18.75 21.75L18.75 23.25', 'M0.75 0.75L2.25 0.75', 'M21.75 0.75L23.25 0.75', 'M12,4.875c.1,0-.375-.034-.375.375A.375.375,0,1,0,12,4.875', 'M12,13.5c.1,0-.375-.034-.375.375A.375.375,0,1,0,12,13.5', 'M2.25 9L21.75 9']],
  ArchiveFolder: ['archive-folder', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75 10.875L20.25 10.875', 'M3.75 7.125L20.25 7.125', 'M3.75 3.375L20.25 3.375', 'M22.5,14.625H15a3,3,0,0,1-6,0H1.5a.75.75,0,0,0-.75.75v3.75a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5v-3.75A.75.75,0,0,0,22.5,14.625Z']],
  ArchiveLocker1: ['archive-locker-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 21.750 L0.750 21.750 Z', 'M10.5 4.5L13.5 4.5', 'M10.5 12.75L13.5 12.75', 'M3.75 21.75L3.75 23.25', 'M20.25 21.75L20.25 23.25', 'M0.75 8.25L23.25 8.25']]
};
exports["default"] = _default;